<button class="sts-btn" type="{{buttonType}}"
        [ngClass]="{'disabled': disabled || formSubmitted}"
        [disabled]="disabled || formSubmitted">
  <span #spanCMS app-sts-cms-txt key="{{key}}" (renderingComplete)="onRenderingComplete(spanCMS)"></span>
  <ng-content *ngIf="noCmsText"></ng-content>
  <img app-sts-cms-image *ngIf="formSubmitted"
       bypass="true" default="/tools/ariel-sts-app/{#clientCode#}/app/assets/clients/{#clientCode#}/images/loader-inside.gif"/>
</button>
